import React, { useEffect, useRef, useState } from "react";
import { BsChatDotsFill } from "react-icons/bs";
import { ImSpinner9 } from "react-icons/im";
import { useDispatch } from "react-redux";
import { Button } from "reactstrap";
import { addSellerChat, toogleChat } from "../../../Redux/reducers/chatSlice";
import { setNewConversationID } from "../../../Redux/reducers/conversationIdSlice";
import { createNotification } from "../../Common/CreateNotification";
import { createMessage } from "../fetchingData/createMessage";
import { updateCurrentUserData } from "../../../Redux/reducers/messagesSlice";

export default function ChatWithSeller({ productName, seller, productID }) {
  const [loading, setIsLoading] = useState(false);
  const isMounted = useRef(true);
  const message = `Hi i am interested in your product ${productName}`;
  const user = localStorage.getItem("thrift-client-token");
  const dataObject = JSON.parse(user);
  const userID = dataObject.id;
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const handleClick = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    try {
      await createMessage({
        message: message,
        sellerId: seller.id,
        customerId: userID,
      });
      if (isMounted.current) {
        setIsLoading(false);
        dispatch(toogleChat());
        dispatch(updateCurrentUserData({
          name: seller.name,
          avatar: seller.avatar,
          status: 'active'
        }))
        dispatch(
          addSellerChat({
            seller: {
              id: seller.id,
              name: seller.name,
              avatar: seller.avatar,
            },
            customer: {
              id: dataObject.id,
              name: dataObject.name,
              avatar: dataObject.avatar,
            },
            message: message,
            position: "left",
            calling_number: seller.phone,
            created_at: new Date().toISOString()
          })
        );
        dispatch(setNewConversationID({ id: seller.id, convContext: 'sellers' }));
      }
    } catch (error) {
      createNotification("Error sending message", error);
    }

  };
  return (
    <div className="chat-seller">
      {/* {seller.id !== userID && (
      <Button color="primary" onClick={handleClick}>
        {`Chat with ${seller.name}  `}
        {loading ? <ImSpinner9 className="animate-spin" /> : <BsChatDotsFill />}
      </Button>
      )}{" "} */}
      {seller.id ? (
        <Button onClick={handleClick} className="d-flex justify-content-center align-items-center" style={{
          borderRadius: '1.2rem',
          gap: '0.5rem'
        }}>
          {loading ? <ImSpinner9 className="animate-spin " /> : <BsChatDotsFill />}
          {`Chat with seller `}
        </Button>
      ) : null}
    </div>
  );
}
